__turbopack_context__.v({
  "code": "IndentContent-module__c7sIJa__code",
  "codeBlock": "IndentContent-module__c7sIJa__codeBlock",
  "container": "IndentContent-module__c7sIJa__container",
  "expanded": "IndentContent-module__c7sIJa__expanded",
  "toggle": "IndentContent-module__c7sIJa__toggle",
});
